import { render, staticRenderFns } from "./deleteCommunityPublicity.vue?vue&type=template&id=491d04ee&scoped=true"
import script from "./deleteCommunityPublicity.vue?vue&type=script&lang=js"
export * from "./deleteCommunityPublicity.vue?vue&type=script&lang=js"
import style0 from "./deleteCommunityPublicity.vue?vue&type=style&index=0&id=491d04ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491d04ee",
  null
  
)

export default component.exports